<template>
    <v-content>
        <v-row >
            <v-col class="title">
                Шаблоны голосовых рассылок
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-btn @click="createTemplate()">Создать новый</v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
            <v-list>
                <v-list-item
                    v-for="template in templates"
                    :key="template.id"
                >
                    <v-list-item-content>
                        <v-list-item-title v-text="template.name"></v-list-item-title>
                    </v-list-item-content>
                    <v-spacer/>
                    <v-list-item-action class="d-inline">
                        <v-btn icon @click="editTemplate(template)">
                            <v-icon color="grey lighten-1">mdi-pencil</v-icon>
                        </v-btn>
                        <v-btn icon @click="removeTemplate(template)">
                            <v-icon color="grey lighten-1">mdi-delete</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
            </v-list>
            </v-col>
        </v-row>
    </v-content>
</template>

<script>
export default {
    name: 'callTemplates',
    data() {
        return {

        }
    },
    created() {
        this.$store.dispatch('GET_TEMPLATES');
    },
    computed: {
        templates() {
            return this.$store.getters.TEMPLATES;
        },
    },
    methods: {
        createTemplate() {
            const route = this.$router.resolve({ path: '/call-templates/create/' });
            this.$router.push({ path: route.href });
        },
        editTemplate(template) {
            const route = this.$router.resolve({ path: `/call-templates/update/${template.id}` });
            this.$router.push({ path: route.href });
        },
        removeTemplate(template) {
            this.$store.dispatch('DELETE_TEMPLATE', template.id)
                .then(() => {
                    this.$toaster.success('Шаблон удален');
                    this.$store.dispatch('GET_TEMPLATES');
                })
                .catch(() => {
                    this.$toaster.error('Неизвестаная ошибка!');
                });
        },
    }
}
</script>

<style>

</style>
